import themed from '@/ui/Theme/themed'
import Notification from './Snackbar'

const themedNotification = themed(Notification)

export { themedNotification as Notification }
export default Notification



// WEBPACK FOOTER //
// ./ui/Notification/index.js